import React, { useEffect, useContext } from 'react';
import TopBar from '../../layout/TopBar';
import ResultadoDetalleContext from '../../../context/resultadosDetalle/resultadoDetalleContext';

const Validador = ( props ) => {

    const resultadoDetalleContext = useContext( ResultadoDetalleContext );

    const { validacion, validarResultado } = resultadoDetalleContext;


    useEffect( () => {

        let oid = props.match.params.oid;
        let id = props.match.params.id;

        validarResultado( oid, id );

        //eslint-disable-next-line
    },[] );

    return ( 
        <div>
            <TopBar />
            <div className="row">
                <p></p>
            </div>
            <div className="row">
                <p></p>
            </div>
            <div className="container">
                <div className="card">
                    <div className="card-body">
                        {
                            !validacion ? 
                                <p className="text-center">Validando resultado</p>
                                :
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-md-12 px5 mt10 text-center">
                                            <h5>Validación de resultado</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <table className="table">
                                            <thead>
                                                <tr className="text-center">
                                                    <th colSpan="2">Información</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td style={{width:'10%'}}><strong>Paciente:</strong></td>
                                                    <td style={{width:'40%'}}>{validacion.paciente}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{width:'10%'}}><strong>Médico:</strong></td>
                                                    <td style={{width:'40%'}}>{validacion.medico}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{width:'5%'}}><strong>Fecha:</strong></td>
                                                    <td style={{width:'45%'}}>{validacion.fecha}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{width:'5%'}}><strong>Folio:</strong></td>
                                                    <td style={{width:'45%'}}>{validacion.folio}</td>
                                                </tr>
                                                <tr className="text-center text-success">
                                                    <td colSpan="2"><h4>Válido</h4></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default Validador;